import { EstadoIncidenciaHost, PrioridadIncidenciaHost, SeveridadIncidenciaHost } from "../shared/model/iso42001/incidencia-host.model";

export interface IncidenciaHostColumn {
  estado: EstadoIncidenciaHost;
  titulo: string;
  descripcion: string;
  icon: string;
  color: string;
}

export interface IncidenciaHostOption<T = string> {
  value: T;
  label: string;
  description?: string;
}

export const INCIDENCIA_HOST_COLUMNS: IncidenciaHostColumn[] = [
  { estado: "ABIERTO", titulo: "Abierto", descripcion: "Reporte registrado", icon: "mark_email_unread", color: "#b71c1c" },
  { estado: "PROCESO", titulo: "Proceso", descripcion: "Atención en curso", icon: "settings_applications", color: "#ef6c00" },
  { estado: "ATENDIDO", titulo: "Atendido", descripcion: "Pendiente de Vo.Bo.", icon: "fact_check", color: "#1976d2" },
  { estado: "VOBO", titulo: "Vo.Bo.", descripcion: "Cerrado por conformidad", icon: "task_alt", color: "#2e7d32" },
];

export const PRIORIDAD_HOST_OPTIONS: IncidenciaHostOption<PrioridadIncidenciaHost>[] = [
  { value: "Alta", label: "Alta" },
  { value: "Media", label: "Media" },
  { value: "Baja", label: "Baja" },
];

export const SEVERIDAD_HOST_OPTIONS: IncidenciaHostOption<SeveridadIncidenciaHost>[] = [
  { value: "Critico", label: "Crítico", description: "Interrupción o afectación mayor del servicio." },
  { value: "Medio", label: "Medio", description: "Afectación parcial o degradación controlada." },
  { value: "Bajo", label: "Bajo", description: "Evento menor sin impacto crítico." },
];
